'use client'

import styles from './Notfound.module.css'

export type NotfoundProps = {
  title: string
  content: React.ReactNode
  button: React.ReactNode
}

export const PhnxNotfound: React.FC<NotfoundProps> = ({ title, content, button }) => {
  return (
    <div className={styles['notfound']}>
      <div className="container">
        {title && (
          <div className={styles.title}>
            <h1>{title}</h1>
          </div>
        )}
        <div className="content">
          {content && content}
          {button && <div className={styles.button}>{button}</div>}
        </div>
      </div>
    </div>
  )
}
